import {ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import DeliverySacResponseSchema from '@/schema/DeliverySacResponse.schema'
import StatusCarga from '@/model/resource/StatusCarga'
import CargaResponsavel from '@/model/resource/CargaResponsavel'
import SacResponse from '@/model/response/SacResponse'
import {CargaInfo} from '@/model/resource/CargaInfo'
import * as Helper from '@/helpers'

export default class DeliverySacResponse extends Resource {
    readonly $name: string = 'DeliverySacResponse'
    readonly $endpoint: string = '/user/carga/sac/reports'

    @ResponseSerialize(SacResponse)
    sacResponse: SacResponse | null = null

    get $schema() {
        // @ts-ignore
        return DeliverySacResponseSchema(this)
    }

    get $id() {
        return this.idCarga
    }

    set $id(val: ID) {
        this.idCarga = val
    }

    idCarga: ID = 0
    nroNotaFiscal: number | null = null
    danfe: string | null = null
    dataPrevisao: string | null = null
    tentativaIndex: number | null = null
    tentativaTotal: number | null = null
    eventoList: String[] | null  = null

    @ResponseSerialize(StatusCarga)
    status = new StatusCarga()

    @ResponseSerialize(CargaResponsavel)
    transportador = new CargaResponsavel()

    @ResponseSerialize(CargaInfo)
    cargaInfo = new CargaInfo()

    get attempt() {
        return this.sacResponse ? this.sacResponse.attempt : ''
    }

    get date() {
        return this.sacResponse ? this.sacResponse.date : ''
    }

    get shipperName() {
        return this.transportador.$tag
    }
    set shipperName(val: string) {
        this.transportador.$tag = val
    }

    get nomeStatus() {
        return this.status.nome
    }
    set nomeStatus(val: string) {
        this.status.nome = val
    }

    get event() {
        return this.sacResponse ? this.sacResponse.event : ''
    }

    get manifest() {
        return this.cargaInfo ? this.cargaInfo.manifesto : ''
    }

    get showPrevisaoReal() {
        return Helper.getPermitirDataReal()
    }
}
